import React from 'react';
import PropTypes from 'prop-types';
import {reject} from 'lodash';
import translate from '../../../utils/translations';
import DeleteAttachment from './DeleteAttachment/DeleteAttachment';
import {EditReservation} from './EditReservation/EditReservation';
import {EditReservationRequest} from './EditReservationRequest/EditReservationRequest';
import {MessageAction} from './MessageAction/MessageAction';
import {messageType} from '../../../utils/appConfigData';

import './Message.less';

export class Message extends React.Component {
    static propTypes = {
        actions: PropTypes.arrayOf(
            PropTypes.shape({
                actionTitle: PropTypes.string,
                actionUrl: PropTypes.string,
            })
        ),
        attachments: PropTypes.arrayOf(
            PropTypes.shape({
                attachmentId: PropTypes.string,
                downloadUrl: PropTypes.string,
                fileName: PropTypes.string,
            })
        ),
        attributes: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string,
                value: PropTypes.string,
            })
        ),
        avatar: PropTypes.string,
        backUrl: PropTypes.string,
        ctaDetails: PropTypes.shape({}),
        displayName: PropTypes.string,
        isHybridInbox: PropTypes.bool,
        role: PropTypes.string,
        sentText: PropTypes.string,
        text: PropTypes.string,
        title: PropTypes.string,
        translations: PropTypes.shape({}),
        type: PropTypes.string,
    };

    static defaultProps = {
        actions: [],
        attachments: [],
        backUrl: '/traveler/th/inbox',
        role: 'SYSTEM',
        translations: {},
    };

    constructor(props) {
        super(props);
    }

    onDeleteComplete = (id) => {
        const updatedAttachments = reject(
            this.props.attachments,
            (attachment) => {
                return attachment.attachmentId === id;
            }
        );
        this.props.onDeleteComplete(updatedAttachments);
    };

    // TODO: Move to GQL
    get title() {
        const {displayName, role, title, translations} = this.props;

        if (!title) {
            if (role === 'TRAVELER') {
                return translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.yousentamessage'
                );
            } else if (role === 'OWNER') {
                return translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.sentamessage',
                    {NAME: displayName}
                );
            }
        }

        return title;
    }

    render() {
        const {
            attributes,
            avatar,
            backUrl,
            ctaDetails,
            conversationId,
            isHybridInbox,
            role,
            sentText,
            text,
            translations,
            type,
        } = this.props;
        let actions = [];
        let attachments = [];
        let messageText;

        if (type === messageType.EDIT_RESERVATION_REQUEST) {
            return (
                <EditReservationRequest
                    attributes={attributes}
                    avatar={avatar}
                    role={role}
                    sentText={sentText}
                    text={text}
                    translations={translations}
                />
            );
        } else if (type === messageType.EDIT_RESERVATION) {
            return attributes?.length ? (
                <EditReservation
                    attributes={attributes}
                    avatar={avatar}
                    role={role}
                    sentText={sentText}
                    translations={translations}
                />
            ) : null;
        }

        if (this.props.actions) {
            this.props.actions.forEach((action, index) => {
                actions.push(
                    <MessageAction
                        actionTitle={action.actionTitle}
                        actionUrl={action.actionUrl}
                        backUrl={backUrl}
                        ctaDetails={ctaDetails}
                        conversationId={conversationId}
                        isHybridInbox={isHybridInbox}
                        key={index}
                    />
                );
            });
        }

        if (this.props.attachments) {
            this.props.attachments.forEach((attachment, index) => {
                attachments.push(
                    <DeleteAttachment
                        attachmentId={attachment.attachmentId}
                        downloadUrl={attachment.downloadUrl}
                        fileName={attachment.fileName}
                        key={index}
                        onDeleteComplete={this.onDeleteComplete}
                        role={role}
                        translations={translations}
                    />
                );
            });
        }

        if (text) {
            if (role === 'SYSTEM') {
                messageText = <span>{text}</span>;
            } else {
                messageText = (
                    <em>
                        <span className="hidden-xs">{'"'}</span>
                        {text}
                        <span className="hidden-xs">{'"'}</span>
                    </em>
                );
            }
        }

        return (
            <div className={`Message Message--${role}`}>
                <div className="Message__avatar">
                    <div
                        className="Message__avatar__image img-circle"
                        style={{backgroundImage: `url('${avatar}')`}}
                    />
                </div>

                <div className="clearfix">
                    <h4 className="Message__title">{this.title}</h4>
                    <div className="Message__time">{sentText}</div>
                </div>

                {messageText && (
                    <div className="Message__body">{messageText}</div>
                )}

                {actions.length > 0 && (
                    <div className="Message__actions">{actions}</div>
                )}

                {attachments.length > 0 && (
                    <div className="Message__attachments">{attachments}</div>
                )}
            </div>
        );
    }
}
